class analysis {
  constructor() {
    this._queryMapServer = null;
  }
}

/**
 * 初始化服务查询
 * @param {String} serverUrl 服务地址
 * @param {String} layerName 图层组名
 * @returns 
 */
analysis.prototype.initServer = function (serverUrl, layerName) {
  this._queryMapServer = new mars3d.query.QueryGeoServer({
    url: serverUrl, // ?要不要直接在这里加wfs
    layer: layerName,
  });
  return this._queryMapServer;
};

/**
 * 查询
 * @param {*} queryMapServer QueryGeoServer
 * @param {Object} queryByAttr 按属性查询
 * @param {Object} queryByGeom 按空间范围查询
 * @param {String} queryBySql 按cql查询
 * @returns 
 */
analysis.prototype.query = function (queryMapServer, queryByAttr, queryByGeom, queryBySql) {
  if (queryByAttr) {
    const { column, text } = queryByAttr;
    return new Promise((resolve) => {
      queryMapServer.query({
        column: column,
        text: text,
        page: false,
        success: (result) => {
          resolve(result);
        },
        error: (error) => {
          console.log("访问错误：", error);
          return;
        },
      });
    });
  } else if (queryByGeom) {
    const { graphic, geometryName } = queryByGeom;
    return new Promise((resolve) => {
      queryMapServer.query({
        graphic: graphic,
        geometryName: geometryName,
        page: false,
        success: (result) => {
          resolve(result);
        },
        error: (error) => {
          console.log("访问错误：", error);
          return;
        },
      });
    });
  } else if (queryBySql) {
    return new Promise((resolve) => {
      queryMapServer.query({
        cql_filter: queryBySql,
        page: false,
        success: (result) => {
          resolve(result);
        },
        error: (error) => {
          console.log("访问错误：", error);
          return;
        },
      });
    });
  }
};

export default analysis;